import { sortLayersByOrder } from "../../configuration/utils.js";
const fusion = values => {
  const layers = [];

  // BODY
  layers.push({ folder: "BODY", imageName: values.EV_MODELO });

  // RIGHT SIDE
  if (
    !["SCHUKO_TYPE_E", "SCHUKO_TYPE_F"].some(type =>
      values.EV_RIGHT_SIDE.includes(type)
    )
  ) {
    if (values.EV_RIGHT_SIDE.includes("MANGUERA")) {
      layers.push({
        folder: "RIGHT_SIDE",
        imageName: values.EV_RIGHT_SIDE + "_" + values.EV_LONGITUD_MANGUERA,
      });
    } else {
      layers.push({ folder: "RIGHT_SIDE", imageName: values.EV_RIGHT_SIDE });
    }
  }

  // LEFT SIDE
  if (values.EV_LEFT_SIDE.includes("MANGUERA")) {
    layers.push({
      folder: "LEFT_SIDE",
      imageName: values.EV_LEFT_SIDE + "_" + values.EV_LONGITUD_MANGUERA,
    });
  } else {
    layers.push({ folder: "LEFT_SIDE", imageName: values.EV_LEFT_SIDE });
  }

  // OTHERS
  if (values.EV_CONTACTLESS) {
    layers.push({ folder: "OTHERS", imageName: "CONTACTLESS" });
  }

  if (values.EV_PULSADOR_EMERGENCIA === true) {
    layers.push({ folder: "OTHERS", imageName: "PULSADOR_EMERGENCIA" });
  }

  if (values.EV_MOBILE) {
    layers.push({ folder: "OTHERS", imageName: "MOBILE" })
  }

  // ORDEN PERSONALIZADO
  const layerOrder = [
    "RIGHT_SIDE",
    "BODY",
    "LEFT_SIDE",
    "OTHERS:PULSADOR_EMERGENCIA",
    "OTHERS:MOBILE",
    "OTHERS:CONTACTLESS",
  ];

  return sortLayersByOrder(layers, layerOrder);
};

export default fusion;
